import React from 'react';

import { Icon } from '@chakra-ui/react';

export const NetworkPortIcon = props => (
  <Icon viewBox="19 19 38 40" color="inherit" h="full" w="full" {...props}>
    <path
      fill="currentColor"
      fillOpacity="1"
      strokeWidth="0.2"
      strokeLinejoin="round"
      d="M 40,44L 39.9999,51L 44,51C 45.1046,51 46,51.8954 46,53L 46,57C 46,58.1046 45.1045,59 44,59L 32,59C 30.8954,59 30,58.1046 30,57L 30,53C 30,51.8954 30.8954,51 32,51L 36,51L 36,44L 40,44 Z M 47,53L 57,53L 57,57L 47,57L 47,53 Z M 29,53L 29,57L 19,57L 19,53L 29,53 Z M 29.9923,41.9999L 31.0398,36L 26.0475,36L 26.7458,32L 31.7381,32L 32.2619,29L 27.2696,29L 27.9679,25L 32.9602,25L 34.0077,18.9999L 38.0077,18.9999L 36.9602,25L 40.9602,25L 42.0078,18.9999L 46.0077,18.9999L 44.9602,25L 48.9679,25L 48.2696,29L 44.2619,29L 43.7382,32L 47.7458,32L 47.0475,36L 43.0398,36L 41.9924,41.9999L 37.9924,41.9999L 39.0398,36L 35.0398,36L 33.9923,41.9999L 29.9923,41.9999 Z M 35.7381,32L 39.7382,32L 40.2619,29L 36.2619,29L 35.7381,32 Z "
    />
  </Icon>
);
